import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { IconButton, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import OpenWithOutlinedIcon from '@mui/icons-material/OpenWithOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DangerousOutlinedIcon from '@mui/icons-material/DangerousOutlined';

const Actions = (context: any) => {
  const cellData = context.cell.getData();
  return       <>
    <Tooltip placement='top' title={context.props.t('INFO')}>
      <IconButton
        onClick={(event) => {
          console.log(event);
          context.props.buttonAction(event);
          context.props.getSensorInfo(cellData.sensor_id);
        }}
      >
        <InfoOutlinedIcon fontSize='small' color='info'/>
      </IconButton>
    </Tooltip>
    <Tooltip placement='top' title={context.props.t('MOVE_NFTS')}>
      <IconButton
        onClick={(event) => {
          context.props.buttonAction(event);
          context.props.moveNfts(cellData);
        }}
      >
        <OpenWithOutlinedIcon fontSize='small'  color="success"/>
      </IconButton>
    </Tooltip>
    <Tooltip  placement='top' title={context.props.t('CHANGE_MAIL')}>
      <IconButton
      
        onClick={(event) => {
          context.props.buttonAction(event);
          context.props.changeMailSensor(cellData.sensor_id);
        }}
      >
        <EmailOutlinedIcon  fontSize='small' color="success"/>
      </IconButton>
    </Tooltip>
    <Tooltip placement='top' title={context.props.t('DELETE_ORDER')}>
      <IconButton
        onClick={(event) => {
          context.props.buttonAction(event);
          context.props.deleteDeviceOwner(cellData.sensor_id);
        }}
      >
        <DeleteOutlineOutlinedIcon fontSize='small' color='error'/>
      </IconButton>
    </Tooltip>
    <Tooltip placement='top' title={context.props.t('BAN_CONTACT')}>
      <IconButton
        onClick={(event) => {
          context.props.buttonAction(event);
          context.props.banSensor(cellData);
        }}
      >
        <DangerousOutlinedIcon fontSize='small' color={cellData?.is_banned ? 'error' : 'info'} />
      </IconButton>
    </Tooltip>
  </>;
};

export default Actions;
